// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.13182"][{"4424":0}[chunkId]] || "1.13184") + "/" + chunkId + ".js";
};